module.exports = __webpack_public_path__ + "img/冻鲜.a57a93fa.png";